import { render, staticRenderFns } from "./ShopSkinDtView.vue?vue&type=template&id=aadc3148&scoped=true"
import script from "./ShopSkinDtView.vue?vue&type=script&lang=js"
export * from "./ShopSkinDtView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aadc3148",
  null
  
)

export default component.exports